// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + {"1259":"private-profile-actions","4061":"post-actions","9060":"feed-page-modals"}[chunkId] + ".chunk.min.css";
};